function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1A171B;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#303231;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#00893F;fill-opacity:0.25;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Group 53");

var _ref4 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "HFP-"
}, React.createElement("g", {
  transform: "translate(-48.000000, -130.000000)"
}, React.createElement("g", {
  id: "Group-53",
  transform: "translate(48.000000, 130.000000)"
}, React.createElement("g", {
  id: "Group-52"
}, React.createElement("path", {
  id: "Fill-1",
  className: "st0",
  d: "M10.3,51.5c0-0.1,0.1-0.2,0.1-0.4C10.4,51.3,10.3,51.4,10.3,51.5"
}), React.createElement("path", {
  id: "Fill-3",
  className: "st0",
  d: "M181,50.5c0.1,0.1,0.2,0.2,0.3,0.3C181.2,50.6,181.1,50.5,181,50.5"
}), React.createElement("path", {
  id: "Fill-5",
  className: "st0",
  d: "M180.2,50c0.1,0,0.2,0.1,0.4,0.2C180.5,50.1,180.4,50,180.2,50"
}), React.createElement("path", {
  id: "Fill-7",
  className: "st0",
  d: "M10.7,50.7c0.1-0.1,0.2-0.2,0.3-0.3C10.9,50.5,10.8,50.6,10.7,50.7"
}), React.createElement("path", {
  id: "Fill-9",
  className: "st0",
  d: "M181.6,51.2c0.1,0.1,0.1,0.2,0.1,0.4C181.7,51.4,181.6,51.3,181.6,51.2"
}), React.createElement("path", {
  id: "Fill-11",
  className: "st0",
  d: "M11.4,50.2c0.1-0.1,0.2-0.1,0.4-0.2C11.6,50,11.5,50.1,11.4,50.2"
}), React.createElement("path", {
  id: "Fill-13",
  className: "st0",
  d: "M11,50.5c0.1-0.1,0.3-0.2,0.4-0.3C11.2,50.3,11.1,50.3,11,50.5"
}), React.createElement("path", {
  id: "Fill-15",
  className: "st0",
  d: "M10.4,51.2c0.1-0.2,0.2-0.3,0.3-0.4C10.6,50.9,10.5,51,10.4,51.2"
}), React.createElement("path", {
  id: "Fill-17",
  className: "st0",
  d: "M180.6,50.2c0.1,0.1,0.3,0.2,0.4,0.3C180.9,50.3,180.8,50.3,180.6,50.2"
}), React.createElement("path", {
  id: "Fill-19",
  className: "st0",
  d: "M10.2,52.1c0-0.2,0.1-0.4,0.1-0.5C10.2,51.7,10.2,51.9,10.2,52.1"
}), React.createElement("path", {
  id: "Fill-21",
  className: "st0",
  d: "M180.2,50c0,0-0.1,0-0.1-0.1l-0.4-0.1h-0.4C179.7,49.8,180,49.9,180.2,50"
}), React.createElement("path", {
  id: "Fill-23",
  className: "st0",
  d: "M11.7,50c0.3-0.1,0.5-0.2,0.8-0.2h-0.4l-0.2,0.1C11.8,49.9,11.8,50,11.7,50"
}), React.createElement("path", {
  id: "Fill-25",
  className: "st0",
  d: "M181.3,50.7c0.1,0.1,0.2,0.3,0.3,0.4C181.5,51,181.4,50.9,181.3,50.7"
}), React.createElement("path", {
  id: "Fill-27",
  className: "st0",
  d: "M181.7,51.5c0.1,0.2,0.1,0.4,0.1,0.5C181.8,51.9,181.8,51.7,181.7,51.5"
}), React.createElement("g", {
  id: "Group-31",
  transform: "translate(0.000000, 0.126556)"
}, React.createElement("g", {
  id: "Clip-30"
}), React.createElement("path", {
  className: "st1",
  d: "M181.9,144.8L181.9,144.8V75.2h7.6c1.4,0,2.5-1.1,2.5-2.5V52.2c0-1.4-1.1-2.5-2.5-2.5h-9.7l0.4,0.1 c0,0,0.1,0,0.1,0.1c-0.3-0.1-0.5-0.2-0.8-0.2h0.4l-62.1-22v-9.3h4.8c1.1,0,2.1-0.8,2.4-1.9c0.3-1.1-0.3-2.3-1.3-2.8L97.1,0.1 c-0.7-0.4-1.6-0.4-2.3,0L68.6,13.7c-1,0.5-1.5,1.7-1.3,2.8c0.3,1.1,1.3,1.9,2.4,1.9h4.6v9.2L12.2,49.7h0.4 c-0.3,0-0.6,0.1-0.8,0.2c0,0,0.1,0,0.1-0.1l0.4-0.1H2.5c-1.4,0-2.5,1.1-2.5,2.5v20.6c0,1.4,1.1,2.5,2.5,2.5h7.6v69.5 M117.7,33 L163,49.7h-45.3V33z M96,5.1l16.2,8.3H79.9L96,5.1z M79.3,31.3v-5.2v-7.7h33.4v7.8v5.2v18.4H79.3V31.3z M74.3,32.9v16.9H28.9 L74.3,32.9z M39.1,144.7H25.7v-49h13.4V144.7z M109.7,144.7h-55v-49h55V144.7z M142.8,144.7h-17.6v-49h17.6V144.7z  M165.4,144.7h-17.6v-49h17.6V144.7z M176.9,144.7h-6.6V93.2c0-1.4-1.1-2.5-2.5-2.5h-45.1c-1.4,0-2.5,1.1-2.5,2.5v51.5h-5.7 V93.2c0-1.4-1.1-2.5-2.5-2.5H52c-1.4,0-2.5,1.1-2.5,2.5v51.5H44V93.2c0-1.4-1.1-2.5-2.5-2.5H23.2c-1.4,0-2.5,1.1-2.5,2.5v51.5 H15V75.2h161.8L176.9,144.7L176.9,144.7z M5,70.2V54.6h182v15.6H5z"
})), React.createElement("path", {
  id: "Fill-32",
  className: "st2",
  d: "M93.9,29.6c1.2-0.8,2.6-1.3,4.1-1.3c1.4,0,2.7,0.5,3.9,1.2c-0.4-0.6-0.9-1.2-1.5-1.7 c-1.2-0.9-2.7-1.5-4.4-1.5c-1.5,0-3,0.5-4.1,1.3c-1.8,1.3-3,3.4-3,5.8c0,2.5,1.3,4.7,3.2,6c-0.7-1.1-1.2-2.5-1.2-3.9 C90.9,33,92.1,30.9,93.9,29.6"
}), React.createElement("path", {
  id: "Fill-34",
  className: "st2",
  d: "M109.6,32c-0.7-2.4-2.2-4.5-4.1-6.1c0.9,1.2,1.6,2.5,2.1,4c0.3,1.1,0.5,2.2,0.5,3.4 c0,6.7-5.4,12.1-12.1,12.1c-2.8,0-5.4-1-7.4-2.6c2.2,2.8,5.6,4.7,9.5,4.7c6.7,0,12.1-5.4,12.1-12.1 C110.2,34.2,109.9,33.1,109.6,32"
}), React.createElement("path", {
  id: "Fill-36",
  className: "st1",
  d: "M88.8,33.4c0-2.4,1.2-4.5,3-5.8c1.2-0.8,2.6-1.3,4.1-1.3c1.7,0,3.2,0.6,4.4,1.5 c0.6,0.5,1.1,1.1,1.5,1.7c0.8,1.1,1.2,2.4,1.2,3.9c0,3.9-3.2,7.2-7.2,7.2c-1.4,0-2.8-0.4-3.9-1.2C90.1,38,88.8,35.9,88.8,33.4  M107.6,30c-0.4-1.5-1.1-2.8-2.1-4c-0.8-1-1.8-2-2.9-2.7c-1.9-1.3-4.2-2-6.7-2c-0.1,0-0.1,0-0.1,0c-0.2,0-0.3,0-0.5,0.1 c-0.1,0-0.2,0-0.3,0h-0.1c-1.8,0.2-3.6,0.7-5.1,1.6c-2.6,1.5-4.5,4-5.4,6.9c-0.3,1.1-0.6,2.3-0.6,3.5c0,3.9,1.9,7.3,4.7,9.5 c2.1,1.6,4.6,2.6,7.4,2.6c6.7,0,12.1-5.4,12.1-12.1C108.1,32.2,107.9,31.1,107.6,30"
}), React.createElement("polyline", {
  id: "Fill-38",
  className: "st2",
  points: "28.9,49.8 74.3,33 74.3,40  "
}), React.createElement("polyline", {
  id: "Fill-40",
  className: "st2",
  points: "117.7,33.1 163,49.8 117.7,40.1  "
}), React.createElement("polyline", {
  id: "Fill-42",
  className: "st2",
  points: "32.8,144.8 25.7,144.8 25.7,95.8 32.8,95.8  "
}), React.createElement("polyline", {
  id: "Fill-44",
  className: "st2",
  points: "65.3,144.8 54.7,144.8 54.7,95.8 65.3,95.8  "
}), React.createElement("polyline", {
  id: "Fill-46",
  className: "st2",
  points: "132.3,144.8 125.2,144.8 125.2,95.8 132.3,95.8  "
}), React.createElement("polyline", {
  id: "Fill-48",
  className: "st2",
  points: "154.9,144.8 147.8,144.8 147.8,95.8 154.9,95.8  "
}), React.createElement("polygon", {
  id: "Fill-50",
  className: "st2",
  points: "187,54.8 8.3,54.8 5,54.8 5,63.3 5,70.4 10.4,70.4 10.4,61.1 187,61.1  "
})))));

var SvgStoreBuilding = function SvgStoreBuilding(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "340px",
    height: "145px",
    viewBox: "0 0 340 145",
    style: {
      enableBackground: "new 0 0 340 145"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStoreBuilding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/store-building.e45881a0.svg";
export { ForwardRef as ReactComponent };